export const Container = ({ children }) => {
  return <div className="container">{children}</div>;
};
